(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dx-calculadora"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dx-calculadora')) {
    customElements.define(
      'dx-calculadora',
      class extends HTMLElement {
        connectedCallback() {
          this.rango = this.querySelector('input[type="range"]');
          if (!this.rango) return;
          this.horas = this.querySelector('[data-dx-horas]');
          this.comentario = this.querySelector('[data-dx-comentario]');
          this.dias = [...this.querySelectorAll('.dx-calc__dias i')];
          this.datos = {
            semana: this.querySelector('[data-dx-dato="semana"]'),
            anio: this.querySelector('[data-dx-dato="anio"]'),
            vida: this.querySelector('[data-dx-dato="vida"]'),
          };
          this.valores = { semana: 0, anio: 0, vida: 0 };
          this.suave = document.documentElement.classList.contains('dx-anim');
          this.numero = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 1 });
          this.decimal = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

          this.rango.addEventListener('input', () => this.actualizar());

          /* La cuenta arranca cuando la sección se ve por primera vez, para que se note el cambio */
          if (this.suave && 'IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              ([entrada]) => {
                if (!entrada.isIntersecting) return;
                this.observer.disconnect();
                setTimeout(() => this.actualizar(), 400);
              },
              { threshold: 0.3 }
            );
            this.observer.observe(this);
          } else {
            this.actualizar();
          }

          const inicio = Date.now();
          const reloj = this.querySelector('[data-dx-reloj]');
          this.intervalo = setInterval(() => {
            const s = Math.floor((Date.now() - inicio) / 1000);
            reloj.textContent = `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
          }, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.intervalo);
          this.observer?.disconnect();
          cancelAnimationFrame(this.marco);
        }

        actualizar() {
          const h = Number(this.rango.value);
          const min = Number(this.rango.min);
          const max = Number(this.rango.max);
          this.rango.style.setProperty('--p', `${((h - min) / (max - min)) * 100}%`);
          this.rango.setAttribute('aria-valuetext', `${this.numero.format(h)} horas al día`);
          this.horas.textContent = this.numero.format(h);

          const despierto = Math.round((h / 16) * 100);
          this.comentario.textContent = `Es el ${despierto} % del tiempo que pasas despierto.`;

          const objetivo = { semana: h * 7, anio: (h * 365) / 24, vida: (h * 50) / 24 };
          const perdidos = Math.round(objetivo.anio);
          this.dias.forEach((dia, i) => dia.classList.toggle('is-perdido', i < perdidos));
          this.animarNumeros(objetivo);
        }

        animarNumeros(objetivo) {
          cancelAnimationFrame(this.marco);
          const desde = { ...this.valores };
          const duracion = this.suave ? 450 : 0;
          const inicio = performance.now();
          const paso = (t) => {
            const p = duracion ? Math.min(1, (t - inicio) / duracion) : 1;
            const e = 1 - Math.pow(1 - p, 3);
            for (const clave in objetivo) {
              this.valores[clave] = desde[clave] + (objetivo[clave] - desde[clave]) * e;
            }
            this.datos.semana.textContent = this.numero.format(Math.round(this.valores.semana));
            this.datos.anio.textContent = this.numero.format(Math.round(this.valores.anio));
            this.datos.vida.textContent = this.decimal.format(this.valores.vida);
            if (p < 1) this.marco = requestAnimationFrame(paso);
          };
          this.marco = requestAnimationFrame(paso);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dx-como-funciona"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dx-pestanas')) {
    customElements.define(
      'dx-pestanas',
      class extends HTMLElement {
        connectedCallback() {
          this.pestanas = [...this.querySelectorAll('[role="tab"]')];
          this.indicador = this.querySelector('.dx-como__indicador');
          this.addEventListener('click', this.alPulsar);
          this.addEventListener('keydown', this.alTeclear);

          /* Los pasos del panel visible entran cuando la sección aparece en pantalla */
          this.observer = new IntersectionObserver(
            ([e]) => {
              if (!e.isIntersecting) return;
              this.observer.disconnect();
              this.mostrarPasos(this.querySelector('.dx-como__panel:not([hidden])'));
            },
            { threshold: 0.2 }
          );
          this.observer.observe(this);

          this.colocarIndicador();
          this.alRedimensionar = () => this.colocarIndicador();
          window.addEventListener('resize', this.alRedimensionar, { passive: true });
          document.fonts?.ready.then(() => this.colocarIndicador());
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          window.removeEventListener('resize', this.alRedimensionar);
        }

        alPulsar = (e) => {
          const pestana = e.target.closest('[role="tab"]');
          if (pestana) this.elegir(pestana);
        };

        alTeclear = (e) => {
          const i = this.pestanas.indexOf(document.activeElement);
          if (i < 0) return;
          const siguiente = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.pestanas.length - 1 }[e.key];
          if (siguiente === undefined) return;
          e.preventDefault();
          const pestana = this.pestanas[(siguiente + this.pestanas.length) % this.pestanas.length];
          pestana.focus();
          this.elegir(pestana);
        };

        elegir(pestana) {
          if (pestana.getAttribute('aria-selected') === 'true') return;
          this.pestanas.forEach((p) => {
            const activa = p === pestana;
            p.setAttribute('aria-selected', String(activa));
            p.tabIndex = activa ? 0 : -1;
            const panel = document.getElementById(p.getAttribute('aria-controls'));
            if (panel) panel.hidden = !activa;
          });
          this.colocarIndicador();
          const panel = document.getElementById(pestana.getAttribute('aria-controls'));
          panel?.querySelector('.dx-como__pasos')?.scrollTo({ left: 0 });
          this.mostrarPasos(panel);
        }

        mostrarPasos(panel) {
          if (!panel) return;
          const pasos = [...panel.querySelectorAll('.dx-como__paso')];
          pasos.forEach((p) => p.classList.remove('dx-visible'));
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              pasos.forEach((p, i) => {
                p.style.setProperty('--dx-retraso', `${i * 90}ms`);
                p.classList.add('dx-visible');
              })
            )
          );
        }

        colocarIndicador() {
          const activa = this.pestanas.find((p) => p.getAttribute('aria-selected') === 'true');
          if (!activa || !this.indicador) return;
          this.indicador.style.setProperty('--dx-x', `${activa.offsetLeft}px`);
          this.indicador.style.setProperty('--dx-ancho', `${activa.offsetWidth}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dx-hero"] && !Shopify.designMode) return;
  try {
    
  /* Palabra del titular que rota: la primera la pinta Liquid, el resto entra cada pocos segundos */
  (() => {
    const html = document.documentElement;
    const arrancar = (raiz = document) => {
      raiz.querySelectorAll('.dx-rota').forEach((rota) => {
        if (rota.dataset.dxListo || !html.classList.contains('dx-anim')) return;
        const opciones = rota.dataset.opciones.split('|').map((o) => o.trim()).filter(Boolean);
        if (opciones.length < 2) return;
        rota.dataset.dxListo = 'true';
        const texto = rota.firstElementChild;
        let i = 0;
        const hero = rota.closest('.dx-hero');
        const espera = parseFloat(getComputedStyle(hero || rota).getPropertyValue('--dx-fin')) || 2000;
        setTimeout(function cambiar() {
          if (!document.hidden) {
            rota.classList.remove('is-entra');
            rota.classList.add('is-sale');
            setTimeout(() => {
              i = (i + 1) % opciones.length;
              texto.textContent = opciones[i];
              rota.classList.remove('is-sale');
              void rota.offsetWidth;
              rota.classList.add('is-entra');
            }, 280);
          }
          setTimeout(cambiar, 2600);
        }, espera + 1800);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => arrancar());
    else arrancar();
    document.addEventListener('shopify:section:load', (e) => arrancar(e.target));
  })();

  /* Barra de compra del móvil: sale al dejar atrás el hero y se esconde al llegar a los productos */
  if (!customElements.get('dx-barra')) {
    customElements.define(
      'dx-barra',
      class extends HTMLElement {
        connectedCallback() {
          this.hidden = false;
          const hero = this.closest('.section')?.querySelector('.dx-hero');
          const destino = document.querySelector(this.querySelector('a')?.getAttribute('href')?.startsWith('#') ? this.querySelector('a').getAttribute('href') : '#productos');
          const pie = document.querySelector('footer');
          const estado = { hero: true, destino: false, pie: false };
          const actualizar = () => this.classList.toggle('is-visible', !estado.hero && !estado.destino && !estado.pie);
          this.observer = new IntersectionObserver((entradas) => {
            entradas.forEach((e) => {
              if (e.target === hero) estado.hero = e.isIntersecting;
              if (e.target === destino) estado.destino = e.isIntersecting;
              if (e.target === pie) estado.pie = e.isIntersecting;
            });
            actualizar();
          });
          [hero, destino, pie].forEach((el) => el && this.observer.observe(el));
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
